export const Team = () => {
  const teamMembers = [
    {
      name: "Neil Erlichman",
      role: "Counsel",
      image: "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/lt00vivg_Neil%20Erlichman.png",
      imageStyle: "object-cover object-top",
    },
    {
      name: "Matt Kramer",
      role: "Conveyancing",
      image: "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/alc64sou_Matt%20Kramer.png",
      imageStyle: "object-cover object-top",
    },
    {
      name: "Jason Ginchereau",
      role: "Conveyancing",
      image: "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/tjondxi9_Jason%20Ginchereau.png",
      imageStyle: "object-cover object-top",
    },
    {
      name: "Jennifer Arteaga-Palmer",
      role: "Closing & Escrow Services",
      image: "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/exu7r0si_Jennifer%20Arteaga-Palmer.png",
      imageStyle: "object-cover object-top",
    },
    {
      name: "Rachel Basin",
      role: "Sales & Marketing",
      image: "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/6of1rrc5_Rachel%20Basin.png",
      imageStyle: "object-cover object-top",
    },
    {
      name: "Terry Katz",
      role: "Sales & Marketing",
      image: "https://customer-assets.emergentagent.com/job_closing-pros/artifacts/z6g6b9iu_Terry%20Katz.png",
      imageStyle: "object-cover object-top",
    },
  ];

  return (
    <section id="team" className="py-24 lg:py-32 bg-white" data-testid="team-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-4">Leadership</p>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#0F172A] tracking-tight mb-6">
            Our Core Team
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            Led by experienced professionals in title insurance, legal services, and real estate, 
            our leadership team ensures every transaction receives expert oversight.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="group text-center"
              data-testid={`team-member-${index}`}
            >
              <div className="relative mb-4 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className={`w-full aspect-square ${member.imageStyle} grayscale group-hover:grayscale-0 transition-all duration-300`}
                />
                <div className="absolute inset-0 bg-[#0F172A]/0 group-hover:bg-[#0F172A]/10 transition-all duration-300" />
              </div>
              <h3 className="font-serif text-lg font-medium text-[#0F172A] mb-1">
                {member.name}
              </h3>
              <p className="text-sm text-[#B45309] font-medium">
                {member.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
